import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TrailerTemps } from '@asset-solutions/customer-portal/orders/models';

@Component({
  selector: 'orders-temp-sensors',
  imports: [DecimalPipe],
  templateUrl: './temp-sensors.component.html',
  styleUrls: ['./temp-sensors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TempSensorsComponent {
  @Input() set tempSummary(summary: TrailerTemps) {
    this._tempSummary = summary;

    if (this.sensorType === 'sensor') {
      this.sensorData = generateSensorVM(
        { sensor1: summary.sensor1, sensor2: summary.sensor2, sensor3: summary.sensor3 },
        summary.tempMax,
        summary.tempMin,
        'S'
      );
    } else {
      this.sensorData = generateSensorVM(
        { sensor1: summary.returnAir1, sensor2: summary.returnAir2, sensor3: summary.returnAir3 },
        summary.tempMax,
        summary.tempMin,
        'RA'
      );
    }
  }
  get tempSummary(): TrailerTemps {
    return this._tempSummary;
  }

  @Input() sensorType: 'returnAir' | 'sensor' = 'sensor';

  private _tempSummary!: TrailerTemps;

  protected sensorData?: Sensors;
}

function generateSensorVM(
  sensors: { sensor1: number; sensor2: number; sensor3: number },
  tempMax: number,
  tempMin: number,
  labelPrefix: string
): Sensors {
  return {
    sensor1: {
      label: `${labelPrefix}1`,
      value: sensors.sensor1,
      hasDeviation: sensors.sensor1 > tempMax || sensors.sensor1 < tempMin
    },
    sensor2: {
      label: `${labelPrefix}2`,
      value: sensors.sensor2,
      hasDeviation: sensors.sensor2 > tempMax || sensors.sensor2 < tempMin
    },
    sensor3: {
      label: `${labelPrefix}3`,
      value: sensors.sensor3,
      hasDeviation: sensors.sensor3 > tempMax || sensors.sensor3 < tempMin
    }
  };
}

export interface Sensors {
  sensor1: { label: string; value: number; hasDeviation: boolean };
  sensor2: { label: string; value: number; hasDeviation: boolean };
  sensor3: { label: string; value: number; hasDeviation: boolean };
}
